import React,{useState} from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'react-bootstrap';
import './modalBox.css'
const PopupWidget = props => {
  const [lgShow, setLgShow] = useState(false);
  const closeModal=()=>{
    setLgShow(false)
  }
  return (
 
     <>
      {/* <Button onClick={() => setLgShow(true)} className="modal_button_popup">{props.buttonLabel}</Button>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className="modalBox"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {props.modalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>                 
        {props.content} 
        </Modal.Body>
      </Modal> */}
<button type="button" className="btn btn-primary Popup_Button" id="Login_to_view_button" data-toggle="modal" data-target="#GeneralModalCenter" style={{display:'none'}}>
{props.buttonLabel}</button>

<div className="modal" id="GeneralModalCenter" tabIndex="-1" role="dialog" aria-labelledby="GeneralModalCenterTitle" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
    {/* <div className="modal-content modal-lg marketing_background"> */}
    <div className="modal-content modal-lg">
      <div className="modal-header custom_header_modal">
        
    {/* <p className="Paragraph_container shadow">{props.Header}</p> */}
        <button style={{zIndex: 1000}} type="button" id="GeneralModalCenterClose" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body General_Popup_Modal_Body">
      {props.content} 
      </div>
    </div>
  </div>
</div>
      </>
  );
}



export default PopupWidget
